import { AbstractBookingController, AbstractDateRanger, AbstractTariffLoaderer, AbstractUserLoaderer, setBookingControllerSymbols, setDateRangerSymbols, setTariffLoadererSymbols, setUserLoadererSymbols } from '../../generated'
import DateRange from '../../lib/DateRange'
import BookingLoader from '../booking-column/BookingLoader'
import AvailabilityLoader from './AvailabilityLoader'
import { TariffLoader } from './TariffLoader'
import UserLoader from './UserLoader'

export default AbstractBookingController

/** @constructor @extends {AbstractBookingController} @suppress {checkTypes} */ function _BookingController() {}
AbstractBookingController.__implement(AbstractUserLoaderer, AbstractDateRanger, AbstractTariffLoaderer,
 _BookingController.prototype = /** @type {!AbstractBookingController} */ ({
  initialiser(props) {
   const{superBuildingBlock}=this
   superBuildingBlock.initialiser(props)
   const tariffLoader = new TariffLoader() // why can't the loader be only on the column.
   tariffLoader.setState({
    loading:true,
   })
   const userLoader = new UserLoader
   const availabilityLoader = new AvailabilityLoader
   availabilityLoader.setState({
    loading:true,
   })
   const bookingLoader = new BookingLoader()

   const dateRange = new DateRange()

   setTimeout(() => { // clear errors in loader if the range changes
    bookingLoader.setDerivedState({
     /** @this {DateRange} */
     get error() {
      // debugger
      // if (this.state.range) return null
      const{state:{range,startDate,endDate}}=this
      if (range||startDate||endDate)return''
      return undefined
     },
     /** @this {DateRange} */
     get errorText() {
      // debugger
      // const r = ''
      const{state:{range,startDate,endDate}}=this
      if (range||startDate||endDate)return''
      return undefined
     },
    }, dateRange)
   }, 1)

   setDateRangerSymbols(this, {
    _dateRange: dateRange,
   })
   setUserLoadererSymbols(this, {
    _userLoader: userLoader,
   })
   setTariffLoadererSymbols(this, {
    _tariffLoader: tariffLoader,
   })
   setBookingControllerSymbols(this, {
    _bookingLoader: bookingLoader,
    _availabilityLoader: availabilityLoader,
   })
  },
  get showFirstSelectDateRange() {
   const{state:{currentTariff:currentTariff},dateRange:{StartDate:StartDate}}=this
   return(currentTariff=='fiveHours')&&!StartDate
  },
  get showFirstSelectDateSingle() {
   const{state:{currentTariff:currentTariff},dateRange:{StartDate:StartDate}}=this
   return(currentTariff=='twentyFourHours')&&!StartDate
  },
  get shouldShowPlanner(){
   const{state:{currentTariff:currentTariff},dateRange:{EndDate,StartDate:StartDate}}=this
   if(currentTariff=='twentyFourHours'&&StartDate&&EndDate) {
    this.plannerController.props.canSelectRange=false
    return true
   }
   // set planner duration: full day or just one
   // if(currentTariff=='day'&&StartDate) return true
   if((currentTariff=='fiveHours')&&StartDate){
    this.plannerController.props.canSelectRange=true
    return true
   }
   return false
  },
  switchTariff(tariff) {
   const{
    asIBookingController:{state:{booking_id,currentTariff}},
    asIStateful:{setState},Calendar,Planner,
   }=this
   if (booking_id) return

   Calendar.cancel()
   Planner.cancel()
   // if (tariff == 'fiveHours') {
   //   Planner.uncollapse()
   // } else if (currentTariff=='fiveHours') {
   //   Planner.collapse()
   // }
   setState({currentTariff:tariff})
  },
 }),
)
